import { render, staticRenderFns } from "./order-stock-list.vue?vue&type=template&id=80209a2c&scoped=true&"
import script from "./order-stock-list.vue?vue&type=script&lang=js&"
export * from "./order-stock-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80209a2c",
  null
  
)

export default component.exports